export const EXPECTED_SUCESS_QUESTION_DATAHUB_LABEL =
  'Quais aspectos da comunidade não atingiram o sucesso esperado?'

export enum EXPECTED_SUCCESS_VALUES {
  LOW_MEMBER_ENGAGEMENT = 'LOW_MEMBER_ENGAGEMENT',
  MONETIZATION_DIFFICULTIES = 'MONETIZATION_DIFFICULTIES',
  TECNICAL_ISSUES_OR_PLATFORM_LIMITATIONS = 'TECNICAL_ISSUES_OR_PLATFORM_LIMITATIONS',
  LACK_OF_SUPPORT_OR_RESOURCES_FROM_HOTMART = 'LACK_OF_SUPPORT_OR_RESOURCES_FROM_HOTMART',
  ANOTHER_MOTIVE = 'ANOTHER_MOTIVE'
}

export const EXPECTED_SUCCESS_ANSWER_DATAHUB_VALUES = {
  [EXPECTED_SUCCESS_VALUES.LOW_MEMBER_ENGAGEMENT]: {
    label: 'Baixo engajamento dos membros',
    index: 0
  },
  [EXPECTED_SUCCESS_VALUES.MONETIZATION_DIFFICULTIES]: {
    label: 'Dificuldades de monetização',
    index: 1
  },
  [EXPECTED_SUCCESS_VALUES.TECNICAL_ISSUES_OR_PLATFORM_LIMITATIONS]: {
    label: 'Problemas técnicos ou limitações da plataforma',
    index: 2
  },
  [EXPECTED_SUCCESS_VALUES.LACK_OF_SUPPORT_OR_RESOURCES_FROM_HOTMART]: {
    label: 'Falta de suporte ou recursos da Hotmart',
    index: 3
  },
  [EXPECTED_SUCCESS_VALUES.ANOTHER_MOTIVE]: {
    label: 'Outro motivo. Qual?',
    index: 4
  }
}

export const EXPECTED_SUCCESS_OPTIONS = [
  {
    value: EXPECTED_SUCCESS_VALUES.LOW_MEMBER_ENGAGEMENT,
    label: 'community_survey.delete_community.expected_success.option_1'
  },
  {
    value: EXPECTED_SUCCESS_VALUES.MONETIZATION_DIFFICULTIES,
    label: 'community_survey.delete_community.expected_success.option_2'
  },
  {
    value: EXPECTED_SUCCESS_VALUES.TECNICAL_ISSUES_OR_PLATFORM_LIMITATIONS,
    label: 'community_survey.delete_community.expected_success.option_3'
  },
  {
    value: EXPECTED_SUCCESS_VALUES.LACK_OF_SUPPORT_OR_RESOURCES_FROM_HOTMART,
    label: 'community_survey.delete_community.expected_success.option_4'
  },
  {
    value: EXPECTED_SUCCESS_VALUES.ANOTHER_MOTIVE,
    label: 'community_survey.delete_community.expected_success.option_5'
  }
]
